export const copyTextToClipboard = (value: unknown): Promise<void> =>
  navigator.clipboard.writeText(value === null || value === undefined ? '' : String(value))
